var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 49.5L36 29.25M36 29.25L45 38.25M36 29.25L27 38.25M20.25 58.5C12.7942 58.5 6.75 52.4558 6.75 45C6.75 39.0212 10.6367 33.9501 16.0212 32.1756C15.8431 31.2276 15.75 30.2497 15.75 29.25C15.75 20.5515 22.8015 13.5 31.5 13.5C38.7937 13.5 44.9294 18.4578 46.721 25.1872C47.5962 24.9034 48.5302 24.75 49.5 24.75C54.4706 24.75 58.5 28.7794 58.5 33.75C58.5 34.7944 58.3221 35.7973 57.9949 36.73C62.236 38.3414 65.25 42.4437 65.25 47.25C65.25 53.4632 60.2132 58.5 54 58.5H20.25Z",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.2d184836b9f04aa981e994bc18388836.svg";
export { ForwardRef as ReactComponent };